import { React } from "react";
import { useAuth } from 'src/hooks/useAuth';
import { useParams } from "react-router-dom";

const Menu = () => {
    const { logout } = useAuth();
    const handleLogout = (e) => {
        e.preventDefault();
        logout();
    };
    const { work_date } = useParams();
    const currentDate = new Date();
    const formattedDate = currentDate.toISOString().split('T')[0];
    return (
        <>
            <nav className="menu-area mm-menu mm-offcanvas mm-right mm-current mm-opened" id="menu">
                <div className="mm-panels">
                    <div className="mm-panel mm-hasnavbar mm-opened mm-current" id="mm-1">
                        <div className="mm-navbar"><a className="mm-title"><font style={{ verticalAlign: 'inherit' }}><font style={{ verticalAlign: 'inherit' }}>Menu</font></font></a></div>
                        <ul className="mm-listview">
                            <li>
                                <a href={`/scheduleList/${work_date ? work_date : formattedDate}`}><font style={{ verticalAlign: 'inherit' }}><font style={{ verticalAlign: 'inherit' }}>Home</font></font></a>
                            </li>

                            <li>
                                <a href={`/scheduleInput/${work_date ? work_date : formattedDate}`}><font style={{ verticalAlign: 'inherit' }}><font style={{ verticalAlign: 'inherit' }}>Create and Edit Schedules</font></font></a>
                            </li>

                            <li>
                                <a href="/clientList"><font style={{ verticalAlign: 'inherit' }}><font style={{ verticalAlign: 'inherit' }}>Client List</font></font></a>
                            </li>

                            <li>
                                <a href="/projectList"><font style={{ verticalAlign: 'inherit' }}><font style={{ verticalAlign: 'inherit' }}>Project List</font></font></a>
                            </li>

                             <li>
                                <a href="/staffavailability"><font style={{ verticalAlign: 'inherit' }}><font style={{ verticalAlign: 'inherit' }}>Staff Availability</font></font></a>
                            </li>

                            <li>
                                <a href="/userList"><font style={{ verticalAlign: 'inherit' }}><font style={{ verticalAlign: 'inherit' }}>User List</font></font></a>
                            </li>

                            <li>
                                <a href="/comment"><font style={{ verticalAlign: 'inherit' }}><font style={{ verticalAlign: 'inherit' }}>Comments List</font></font></a>
                            </li>

                            <li>
                                <a href="#" onClick={handleLogout}>
                                    <font style={{ verticalAlign: 'inherit' }}><font style={{ verticalAlign: 'inherit' }}>Logout</font></font>
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
            </nav>
        </>
    )
}
export default Menu;
